module.exports = __webpack_public_path__ + "images/panda_jump.png";


//////////////////
// WEBPACK FOOTER
// ./images/panda_jump.png
// module id = 1121
// module chunks = 1